import {PartnerSummaryModel} from '../../../../../partner/common/api/model/partnerSummary.model';
import {SummaryModel} from '../../../../../common/entity/summary.model';
import {Moment} from 'moment-timezone';
import {MedicalRecordPainModel} from '../../../pain/api/model/medicalRecordPain.model';
import {PermissionsModel} from '../../../../../common/entity/permissions.model';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {MedicalRecordProblemModel} from '../../../problem/api/model/medicalRecordProblem.model';

export class MedicalRecordVisitReasonLabelModel{
    lovValue: LovValueSummary;
    customValue: string;
}
